const isWeb = true;
import { getSystemType, isWeixinMiniProgramOrWeixinWebview } from '@nibfe/mkt-env-api';
import { SystemType } from '@nibfe/mkt-env-api/src/libs/enum';
let libs;
if (true)
    libs = require('@nibfe/mkt-libs');
export function debounce(fn, delay) {
    let timer = null;
    // 使用箭头函数保持 this 指向
    return (...args) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn(...args);
            timer = null;
        }, delay);
    };
}
export function getUTM() {
    try {
        const systemType = getSystemType();
        let utm_medium = systemType === SystemType.android ? 'android' : systemType === SystemType.harmony ? 'HarmonyOS' : 'iphone';
        if (isWeb && libs) {
            const { env } = libs;
            if (env.miniProgram.isMiniProgram()) {
                utm_medium = 'WEIXINPROGRAM';
            }
        }
        return utm_medium;
    }
    catch (e) {
        return 'iphone';
    }
}
// 微信小程序侧反爬/风控参数：openIdCipher -> expoId、openId、programName、antiRepPlatform
// 逻辑与 mcp-tex-external-supply-shelf 保持一致
export function getWxRiskParams(ctx) {
    let expoId = '';
    let openId = '';
    let programName = '';
    let antiRepPlatform = '';
    try {
        if (isWeixinMiniProgramOrWeixinWebview()) {
            const { openIdCipher = '', openId: openIdParam = '', programName: programNameParam = '', antiRepPlatform: antiRepPlatformParam = '' } = ctx?._runtimeInfo?.queryParams ?? {};
            expoId = openIdCipher;
            openId = openIdParam;
            programName = programNameParam;
            antiRepPlatform = antiRepPlatformParam;
        }
    }
    catch (e) {
        // 获取微信侧反爬参数异常，忽略即可，不影响主流程
    }
    return {
        expoId,
        openId,
        programName,
        antiRepPlatform
    };
}
